import {atom} from 'recoil';

export const orderSuccessfulProvider = atom({
    key: 'orderSuccessProviders',
    default: false
});